import { render, staticRenderFns } from "./add-product-modal.vue?vue&type=template&id=8598b072&scoped=true&"
import script from "./add-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-product-modal.vue?vue&type=style&index=0&id=8598b072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8598b072",
  null
  
)

export default component.exports